/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
// libraries
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import axios from 'axios';
import { sha256 } from 'js-sha256';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import ReactGA from 'react-ga4';
import { FaChevronDown, FaChevronUp, FaPinterest, FaTelegramPlane } from "react-icons/fa";
import { IoIosArrowBack } from 'react-icons/io';
import { TailSpin } from 'react-loader-spinner';
// utils
import { IconDone } from '../../../../../../assets';
import { trackLead } from '../../../../../../components/whatsAppButton/WhatsAppButton';
import {
    sendUser,
    viewProperties
} from '../../../../../../services/properties';
import {
    MaskPhone, NumeroFormatado, arrumaData, formatarDataEntrega, toPrice,
    useWindowSize
} from '../../../../../../utils/FunctionsGlobals';
import styles from './DetailsPiecesProperties.module.css';

const DetailsPiecesProperties: React.FC<{
    detailsProperties: any;
    managerActual: any;
    site: any;
    origin?: any;
    codsite?: any;
    delegar_ao_agenciador?: any;
}> = ({ detailsProperties, managerActual, site, origin, codsite, delegar_ao_agenciador }) => {
    // constants
    const size = useWindowSize();
    const stylesButton = {
        backgroundColor: `${site?.cor2 || '#00a93a'}`,
        color: site?.cor4,
        cursor: "pointer"
    };

    // useState
    const router = useRouter();
    const { utm_campaign } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const [name, setName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [openForm, setOpenForm] = useState('close');
    const [existUser, setExistUser] = useState<any>(null);
    const [url, setUrl] = useState<any>(null);
    const [acceptPolitic, setAcceptPolitic] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [isEffect, setIsEffect] = useState(false);
    const [interesse, setInteresse] = useState<any>(site?.transacoes[0]);
    const [processando, setProcessando] = useState(false);
    const calcularTotal = (precoLocacao?: number, precoCondominio?: number, precoIptu?: number): number => {
        const locacao = precoLocacao || 0;
        const condominio = precoCondominio || 0;
        const iptu = precoIptu || 0;

        return locacao + condominio + iptu;
    };

    const renderUrl = () => {
        return `https://${site?.site}${router.asPath}`;
    };

    const [expandido, setExpandido] = useState(false); // Estado para controlar se o texto está expandido
    const [exibirBotao, setExibirBotao] = useState(false); // Estado para controlar a visibilidade do botão
    const textoRef = useRef<HTMLDivElement | null>(null); // Referência para a div contendo o texto

    useEffect(() => {
        if (textoRef.current) {
            const alturaTexto = textoRef.current.scrollHeight; // Altura real do texto dentro da div
            const alturaMaxima = 10 * 16; // 20rem convertido para pixels (1rem = 16px padrão)
            setExibirBotao(alturaTexto > alturaMaxima); // Exibe o botão apenas se o texto for maior que o limite
        }
    }, []); // Executa apenas uma vez após o componente ser montado

    const Desc2 = (texto: any) => {
        if (site?.id === "2015") {
            if (texto.includes("https://")) {
                const url = texto.split("https://")[1];
                const textoNew = texto.replace(
                    "https://" + url,
                    `<a href="https://${url}" target="_blank" rel="noreferrer">https://${url}</a>`
                );
                return textoNew;
            }
            return texto;
        }
        return texto;
    };

    function Desc(texto: any){
        if(site?.id == "2015"){
            if(texto.includes("https://")){
                const url = texto.split("https://")[1];
                const textoNew = texto.replace("https://"+url,`<a href="https://${url}" target="_blank" rel="noreferrer">https://${url}</a>`)
                return (<p className={styles.description_properties} dangerouslySetInnerHTML={{ __html: textoNew }}></p>)
            }
            return(<p className={styles.description_properties} dangerouslySetInnerHTML={{ __html: texto }}></p>)
        }
        return(<p className={styles.description_properties} dangerouslySetInnerHTML={{ __html: texto }}></p>)
    }

    function Desc1(texto: any){
        if(site?.id == "2015"){
            if(texto.includes("https://")){
                const url = texto.split("https://")[1];
                const textoNew = texto.replace("https://"+url,`<a href="https://${url}" target="_blank" rel="noreferrer">https://${url}</a>`)
                return (<p className={styles.description_properties} dangerouslySetInnerHTML={{ __html: textoNew }}></p>)
            }
            return(<p className={styles.description_properties} dangerouslySetInnerHTML={{ __html: texto }}></p>)
        }
        return(<p className={styles.description_properties_local} dangerouslySetInnerHTML={{ __html: texto }}></p>)
    }

    useEffect(() => {
        setUrl(renderUrl);
    }, []);

    // methods
    const renderSvg = (label: string) => {
        if (label === 'Tipo do Imóvel') {
            return (
                <svg
                    viewBox="0 0 16 16"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fillRule="evenodd"
                        d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                    ></path>
                    <path
                        fillRule="evenodd"
                        d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                    ></path>
                </svg>
            );
        }
        if (
            [
                'Área Construída',
                'Área Total',
                'Terreno',
                'Dimensões',
                'Área Privativa',
                'Área Útil',
            ].includes(label)
        ) {
            return (
                <svg
                    viewBox="0 0 16 16"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5zm2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5z"></path>
                </svg>
            );
        }
        if (['Dormitórios', 'Suítes'].includes(label)) {
            return (
                <svg
                    viewBox="0 0 640 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                    ></path>
                </svg>
            );
        }
        if (label === 'Banheiros') {
            return (
                <svg
                    viewBox="0 20 512 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M32 384a95.4 95.4 0 0 0 32 71.09V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h256v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-40.91A95.4 95.4 0 0 0 480 384v-48H32zm464-128H80V69.25a21.26 21.26 0 0 1 36.28-15l19.27 19.26c-13.13 29.88-7.61 59.11 8.62 79.73l-.17.17a16 16 0 0 0 0 22.59l11.31 11.31a16 16 0 0 0 22.63 0L283.31 81.94a16 16 0 0 0 0-22.63L272 48a16 16 0 0 0-22.62 0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62l-19.26-19.27A69.25 69.25 0 0 0 32 69.25V256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
                    ></path>
                </svg>
            );
        }
        if (label === "Posição Solar"){
            return (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24px" height="24px">
                    <path d="M 15 3 L 15 8 L 17 8 L 17 3 Z M 7.5 6.09375 L 6.09375 7.5 L 9.625 11.0625 L 11.0625 9.625 Z M 24.5 6.09375 L 20.9375 9.625 L 22.375 11.0625 L 25.90625 7.5 Z M 16 9 C 12.144531 9 9 12.144531 9 16 C 9 19.855469 12.144531 23 16 23 C 19.855469 23 23 19.855469 23 16 C 23 12.144531 19.855469 9 16 9 Z M 16 11 C 18.773438 11 21 13.226563 21 16 C 21 18.773438 18.773438 21 16 21 C 13.226563 21 11 18.773438 11 16 C 11 13.226563 13.226563 11 16 11 Z M 3 15 L 3 17 L 8 17 L 8 15 Z M 24 15 L 24 17 L 29 17 L 29 15 Z M 9.625 20.9375 L 6.09375 24.5 L 7.5 25.90625 L 11.0625 22.375 Z M 22.375 20.9375 L 20.9375 22.375 L 24.5 25.90625 L 25.90625 24.5 Z M 15 24 L 15 29 L 17 29 L 17 24 Z"/>
                </svg>
            );
        }
        if (label === 'Vagas') {
            return (
                <svg
                    viewBox="0 20 512 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                    ></path>
                </svg>
            );
        }
    };
    const RenderDetails = (label: string, value: string) => {
        return (
            <div className={styles.container_caracters}>
                <div className={styles.adjust_title_and_icon}>
                    {label != "Data de Entrega" ? renderSvg(label) : null}
                    <label className={styles.title_info_caracters}>
                        {label}
                    </label>
                </div>
                <label className={styles.result_info_caracters}>{value}</label>
            </div>
        );
    };

    const formatDate = (timestamp: string | number): string => {
        const date = new Date(Number(timestamp)); // Converte para objeto Date
        const currentDate = new Date(); // Data atual
      
        if (date > currentDate) {
          const monthNames = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ];
      
          const month = monthNames[date.getMonth()]; // Nome do mês (0-11)
          const year = date.getFullYear(); // Ano completo
      
          return `${month} de ${year}`; // Formato: "Mês de Ano"
        }
      
        return ""; // Para datas no passado
    }

    const RenderInfoAdditionals = (label: string, x: any) => {
        return (
            <div className={styles.info_additional} key={x}>
                <Image alt="Icone Done" src={IconDone.src} height={15} width={15}/>
                <label className={styles.margin}>{label}</label>
            </div>
        );
    };

    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setName(value);
    };

    const onChangeTelephone = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        const formatTelephone = MaskPhone(value);
        setTelephone(formatTelephone);
    };
    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    const selectTransacao = async () => {
        if(interesse == "Venda"){
            setInteresse("Aluguel")
        } else {
            setInteresse("Venda")
        }
    }

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
    }

    const actionSendUser = async () => {
        if (name != '' && email != '' && telephone != '') {
            const phone = telephone.replace(/[^0-9]/g, '');
            const valida = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 12 && valida) {
                if (re.test(email) == true) {
                    if (acceptPolitic) {
                        if (!processando) {
                            setProcessando(true);
                            setLoadingForm(true);
                            const getSendUser = await sendUser(
                                JSON.stringify(utm_campaign),
                                JSON.stringify(utm_source),
                                JSON.stringify(utm_medium),
                                JSON.stringify(utm_id),
                                JSON.stringify("Interesse no imóvel " + detailsProperties?.id),
                                JSON.stringify(name),
                                JSON.stringify(email),
                                JSON.stringify(telephone),
                                detailsProperties?.id,
                                managerActual?.id && delegar_ao_agenciador ? managerActual?.id : 0,
                                origin,
                                codsite,
                                interesse ? interesse : "",
                                delegar_ao_agenciador ? 1 : 0
                            );
                            setLoadingForm(false);
                            localStorage.setItem(
                                'user',
                                JSON.stringify({
                                    name,
                                    email,
                                    telephone,
                                    id_client: getSendUser?.atendimento?.id_cliente,
                                })
                            );
                            setOpenForm('concluded');
                            setProcessando(false);

                            if (site?.tag_google_head) {
                                const scriptGa = site?.tag_google_head.match(/gtag\('config'(.*?);/g) || site?.tag_google_head.match(/ga\('create'(.*?);/g) || [];
                                const googleAnalytcs = (scriptGa[0] || '')?.split("', '");
                                const TRACKING_ID = (googleAnalytcs[1] || '')?.replace("');", '');

                                // Google Analytics
                                if(TRACKING_ID){
                                    const eventData = {
                                        formData: {
                                            name: name,
                                            email: email,
                                            telefone: telephone,
                                            id_client: getSendUser?.atendimento?.id_cliente,
                                        },
                                        propertyInfo: {
                                            url: 'https://'+site?.site,
                                            referencia: detailsProperties?.referencia,
                                            id: detailsProperties?.id,
                                            preco: detailsProperties?.preco,
                                            preco_loca: detailsProperties?.preco_loca,
                                            tipo: detailsProperties?.tipo?.nome,
                                            empreendimento: detailsProperties?.empreendimento?.nome,
                                            cidade: detailsProperties?.cidade?.nome,
                                            bairro: detailsProperties?.bairro?.nome,
                                            venda: detailsProperties?.venda,
                                            aluguel: detailsProperties?.aluguel
                                        }
                                    };

                                    // Envie o evento para o Google Analytics com informações do imóvel
                                    ReactGA.send({
                                        hitType: 'event',
                                        eventCategory: `Interesse no imóvel ${detailsProperties?.referencia}`,
                                        eventAction: 'Cadastro_Imovel',
                                        eventLabel: JSON.stringify(eventData), // Convertendo as informações em JSON para enviar
                                    });
                                }
                            }

                            const getCookie = (name: string) =>
                                document.cookie
                                .split('; ')
                                .find((row) => row.startsWith(name + '='))
                            ?.split('=')[1] || ''
                            
                            if (site?.fb_token_pixel && site?.fb_id_pixel && getSendUser?.atendimento?.id_cliente) {
                                const accessToken = site?.fb_token_pixel;
                                const pixelId = site?.fb_id_pixel;
                                const currentTimestampInSeconds = Math.floor(Date.now() / 1000);
                    
                                // Normalização dos dados
                                const normalizedName = name.trim().toLowerCase();
                                const normalizedEmail = email.trim().toLowerCase();
                                const normalizedPhone = telephone.replace(/\D/g, ''); // Apenas números
                    
                                // Hash dos dados
                                const hashNome = sha256(normalizedName);
                                const hashEmail = sha256(normalizedEmail);
                                const hashTelefone = sha256(normalizedPhone);
                    
                                const fbc = getCookie('_fbc')
                                const fbp = getCookie('_fbp')
                    
                                let clientIpAddress: string
                                try {
                                    const res6 = await axios.get<{ ip: string }>(
                                    'https://api6.ipify.org?format=json'
                                    )
                                    clientIpAddress = res6.data.ip
                                } catch {
                                    const res4 = await axios.get<{ ip: string }>(
                                    'https://api.ipify.org?format=json'
                                    )
                                    clientIpAddress = res4.data.ip
                                }
                    
                                // Dados do evento
                                const eventData = [
                                    {
                                    event_name: 'Lead',
                                    event_time: currentTimestampInSeconds,
                                    action_source: 'website',
                                    event_source_url: 'https://' + site?.site,
                                    user_data: {
                                        fn: [hashNome],
                                        em: [hashEmail],
                                        ph: [hashTelefone],
                                        fbc: fbc || undefined,
                                        fbp: fbp || undefined,
                                        client_ip_address: clientIpAddress
                                    }
                                }];
                    
                                axios.post(
                                    `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
                                    { data: eventData }
                                )
                                    .then(response => {
                                    console.log('Evento registrado com sucesso:', response.data);
                                    })
                                    .catch(error => {
                                    console.error('Erro ao registrar evento:', error?.response?.data || error.message);
                                });
                            }
                        }
                    } else {
                        alert('Concorde com os termos de uso!');
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para ver mais fotos!'
            );
        }
    };

    const resetForm = () => {
        setOpenForm('close');
        // setName('');
        // setEmail('');
        // setTelephone('');
    };

    const activeOpenForm = () => {
        setOpenForm('open');
    };

    const renderFormStepOne = (type: 'web' | 'mobile') => {
        return (
            <div className={type === 'web' ? styles.form : styles.form_mobile}>
                <div className={styles.adjust_header_form}>
                    <IoIosArrowBack
                        onClick={resetForm}
                        size={26}
                        color={site?.cor1 || 'rgb(183, 157, 90)'}
                        style={{ cursor: 'pointer' }}
                    />
                    <label className={styles.title_form_one}>
                        Tenho interesse neste imóvel
                    </label>
                </div>
                <input
                    className={styles.input}
                    placeholder="Nome"
                    id="Nome_id"
                    value={name}
                    onChange={onChangeName}
                />
                <input
                    className={styles.input}
                    placeholder="Telefone"
                    value={telephone}
                    id="Telefone_id"
                    inputMode='numeric'
                    onChange={onChangeTelephone}
                />
                <input
                    className={styles.input}
                    placeholder="Email"
                    value={email}
                    id="Email_id"
                    onChange={onChangeEmail}
                />
                {detailsProperties.aluguel && detailsProperties.venda ?
                    <>
                        <label className={styles.title_form_one1}>
                            SELECIONE SEU INTERESSE:
                        </label>
                        <ButtonGroup disableElevation variant="contained" color="primary" style={{ marginBottom: "15px" }}>
                            <Button 
                                onClick={selectTransacao} 
                                style={{
                                    borderRadius: "30px 0px 0px 30px",
                                    ...(interesse == "Venda"
                                        ? site?.cor2 == "#ffffff"
                                            ? { backgroundColor: "gray", border: "0.5px solid #707070" }
                                            : { backgroundColor: site?.cor2, border: "0.5px solid #707070" }
                                        : { backgroundColor: "white", color: "#3d3d3d", border: "0.5px solid #707070" })
                                }}
                            >
                                Venda
                            </Button>
                            <Button 
                                onClick={selectTransacao} 
                                style={{
                                    borderRadius: "0px 30px 30px 0px",
                                    ...(interesse == "Aluguel"
                                        ? site?.cor2 == "#ffffff"
                                            ? { backgroundColor: "gray", border: "0.5px solid #707070" }
                                            : { backgroundColor: site?.cor2, border: "0.5px solid #707070" }
                                        : { backgroundColor: "white", color: "#3d3d3d", border: "0.5px solid #707070" })
                                }}
                            >
                                Aluguel
                            </Button>
                        </ButtonGroup>
                    </>
                : null}
                <div className={styles.adjust_checkbox}>
                    <Checkbox
                        style={{ color: 'rgb(126, 126, 126)' }}
                        checked={acceptPolitic}
                        onChange={(event, value) => setAcceptPolitic(value)}
                    />
                    <div className={styles.description_form}>
                        Ao enviar concordo com os
                        <Link prefetch={false} href="/termos">
                            <label className={styles.terms}>
                                termos de uso
                            </label>
                        </Link>
                        e
                        <Link prefetch={false} href="/politica">
                            <label className={styles.terms}>
                                política de privacidade,
                            </label>
                        </Link>
                        para contatar os próximos anunciantes e afirmo ter mais
                        de 18 anos
                    </div>
                </div>
                <a
                    className={
                        acceptPolitic && name != '' && !processando && email != '' && telephone != '' && telephone.length > 13 && telephone.length < 16 && /\S+@\S+\.\S+/.test(email) == true
                            ? styles.action_more
                            : styles.action_more_disabled
                    }
                    onClick={actionSendUser}
                    style={stylesButton}
                >
                    {loadingForm ? (
                        <TailSpin color="white" height={20} width={20} />
                    ) : (
                        'Entrar em contato'
                    )}
                </a>
                <div className={styles.adjust_or}>
                    <div className={styles.line} />
                    <label className={styles.or}>OU</label>
                    <div className={styles.line} />
                </div>
                {site?.id != "1609" ?
                    <a
                        data-gtm-text={`https://api.whatsapp.com/send?phone=55${
                            (managerActual?.id)
                                ? (
                                    managerActual?.telefone ||
                                    managerActual?.telefone_2
                                )?.replace(/\D/g, '')
                                : (
                                    site?.Dados?.tel1 || site?.Dados?.tel2
                                )?.replace(/\D/g, '')
                        }&text=Olá, vi este imóvel no site. Link: ${
                            typeof window !== 'undefined' &&
                            window.location.origin
                        }${
                            typeof window !== 'undefined' &&
                            window.location.pathname
                        }`}
                        className={styles.action_more_whatsapp}
                        href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                    (managerActual?.id)
                                        ? (
                                            managerActual?.telefone ||
                                            managerActual?.telefone_2
                                        )?.replace(/\D/g, '')
                                        : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                            /\D/g,
                                            ''
                                        )
                                }&text=Olá, vi esse imóvel no site quero mais informações - Link: ${
                                    typeof window !== 'undefined' && window.location.origin
                                }${
                                    typeof window !== 'undefined' &&
                                    window.location.pathname
                                }` : `https://api.whatsapp.com/send?phone=55${
                                    (managerActual?.id)
                                        ? (
                                            managerActual?.telefone ||
                                            managerActual?.telefone_2
                                        )?.replace(/\D/g, '')
                                        : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                            /\D/g,
                                            ''
                                        )
                                }&text=Olá, vi esse imóvel no site quero mais informações - Link: ${
                                    typeof window !== 'undefined' && window.location.origin
                                }${
                                    typeof window !== 'undefined' &&
                                    window.location.pathname
                                }`}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático
                        
                            trackLead(site, detailsProperties); // 🔥 Registra o evento Lead
                        
                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                    (managerActual?.id)
                                        ? (
                                            managerActual?.telefone ||
                                            managerActual?.telefone_2
                                        )?.replace(/\D/g, '')
                                        : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                            /\D/g,
                                            ''
                                        )
                                }&text=Olá, vi esse imóvel no site quero mais informações - Link: ${
                                    typeof window !== 'undefined' && window.location.origin
                                }${
                                    typeof window !== 'undefined' &&
                                    window.location.pathname
                                }` : `https://api.whatsapp.com/send?phone=55${
                                    (managerActual?.id)
                                        ? (
                                            managerActual?.telefone ||
                                            managerActual?.telefone_2
                                        )?.replace(/\D/g, '')
                                        : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                            /\D/g,
                                            ''
                                        )
                                }&text=Olá, vi esse imóvel no site quero mais informações - Link: ${
                                    typeof window !== 'undefined' && window.location.origin
                                }${
                                    typeof window !== 'undefined' &&
                                    window.location.pathname
                                }`,
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        rel="noopener noreferrer"
                    >
                        <svg
                            viewBox="0 0 16 16"
                            height="24px"
                            width="24px"
                            aria-hidden="true"
                            focusable="false"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            className="StyledIconBase-ea9ulj-0 fHrGFt"
                            style={{ marginRight: 10 }}
                        >
                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                        </svg>
                        <div>
                            Converse pelo Whatsapp
                        </div>
                    </a>
                : null }
                <a
                    className={styles.action_more_whatsapp}
                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                (managerActual?.id)
                                    ? (
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(/\D/g, '')
                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                        /\D/g,
                                        ''
                                    )
                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                typeof window !== 'undefined' && window.location.origin
                            }${
                                typeof window !== 'undefined' &&
                                window.location.pathname
                            }` : `https://api.whatsapp.com/send?phone=55${
                                (managerActual?.id)
                                    ? (
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(/\D/g, '')
                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                        /\D/g,
                                        ''
                                    )
                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                typeof window !== 'undefined' && window.location.origin
                            }${
                                typeof window !== 'undefined' &&
                                window.location.pathname
                            }`}
                    onClick={async (e) => {
                        e.preventDefault(); // Evita o redirecionamento automático
                    
                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead
                    
                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                        setTimeout(() => {
                        window.open(
                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                (managerActual?.id)
                                    ? (
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(/\D/g, '')
                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                        /\D/g,
                                        ''
                                    )
                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                typeof window !== 'undefined' && window.location.origin
                            }${
                                typeof window !== 'undefined' &&
                                window.location.pathname
                            }` : `https://api.whatsapp.com/send?phone=55${
                                (managerActual?.id)
                                    ? (
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(/\D/g, '')
                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                        /\D/g,
                                        ''
                                    )
                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                typeof window !== 'undefined' && window.location.origin
                            }${
                                typeof window !== 'undefined' &&
                                window.location.pathname
                            }`,
                            "_blank"
                        );
                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                    }}
                    rel="noopener noreferrer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                        height="24px"
                        width="24px"
                        viewBox="0 0 485.213 485.212"
                        style={{ marginRight: 10 }}
                    >
                        <path
                            d="M60.652,75.816V15.163C60.652,6.781,67.433,0,75.817,0c8.38,0,15.161,6.781,15.161,15.163v60.653
                            c0,8.38-6.781,15.161-15.161,15.161C67.433,90.978,60.652,84.196,60.652,75.816z M318.424,90.978
                            c8.378,0,15.163-6.781,15.163-15.161V15.163C333.587,6.781,326.802,0,318.424,0c-8.382,0-15.168,6.781-15.168,15.163v60.653
                            C303.256,84.196,310.042,90.978,318.424,90.978z M485.212,363.906c0,66.996-54.312,121.307-121.303,121.307
                            c-66.986,0-121.302-54.311-121.302-121.307c0-66.986,54.315-121.3,121.302-121.3C430.9,242.606,485.212,296.919,485.212,363.906z
                            M454.89,363.906c0-50.161-40.81-90.976-90.98-90.976c-50.166,0-90.976,40.814-90.976,90.976c0,50.171,40.81,90.98,90.976,90.98
                            C414.08,454.886,454.89,414.077,454.89,363.906z M121.305,181.955H60.652v60.651h60.653V181.955z M60.652,333.584h60.653V272.93
                            H60.652V333.584z M151.629,242.606h60.654v-60.651h-60.654V242.606z M151.629,333.584h60.654V272.93h-60.654V333.584z
                            M30.328,360.891V151.628h333.582v60.653h30.327V94c0-18.421-14.692-33.349-32.843-33.349h-12.647v15.166
                            c0,16.701-13.596,30.325-30.322,30.325c-16.731,0-30.326-13.624-30.326-30.325V60.651H106.14v15.166
                            c0,16.701-13.593,30.325-30.322,30.325c-16.733,0-30.327-13.624-30.327-30.325V60.651H32.859C14.707,60.651,0.001,75.579,0.001,94
                            v266.892c0,18.36,14.706,33.346,32.858,33.346h179.424v-30.331H32.859C31.485,363.906,30.328,362.487,30.328,360.891z
                            M303.256,242.606v-60.651h-60.648v60.651H303.256z M409.399,363.906h-45.49v-45.49c0-8.377-6.781-15.158-15.163-15.158
                            s-15.159,6.781-15.159,15.158v60.658c0,8.378,6.777,15.163,15.159,15.163h60.653c8.382,0,15.163-6.785,15.163-15.163
                            C424.562,370.692,417.781,363.906,409.399,363.906z"
                        />
                    </svg>
                    Agendar Visita
                </a>
            </div>

        );
    };

    const renderFormStepLast = (type: 'web' | 'mobile') => {
        return (
            <div
                className={
                    type === 'web'
                        ? styles.form_concluded
                        : styles.form_concluded_mobile
                }
            >
                <FaTelegramPlane
                    size={80}
                    color="white"
                    style={{ marginTop: 30, marginBottom: 10 }}
                />
                <label className={styles.congratulations}>Pronto!</label>
                <label className={styles.congratulations_description}>
                    Sua mensagem foi enviada, agora é só aguardar o contato do
                    corretor.
                </label>
                <div
                    className={styles.finish}
                    onClick={resetForm}
                    style={stylesButton}
                >
                    Ok
                </div>
            </div>
        );
    };

    const renderForm = () => {
        if (openForm === 'open') {
            return renderFormStepOne('web');
        }
        if (openForm === 'close') {
            return (
                <div className={styles.column_form}>
                    <button
                        className={styles.action_more}
                        onClick={activeOpenForm}
                        style={stylesButton}
                    >
                        Quero mais informações
                    </button>
                    <div className={styles.adjust_or}>
                        <div className={styles.line} />
                        <label className={styles.or}>OU</label>
                        <div className={styles.line} />
                    </div>
                    {site?.id != "1609" ?
                        <div className={styles.action_more_whatsapp}>
                            <a
                                data-gtm-text={`https://api.whatsapp.com/send?phone=55${
                                    (managerActual?.id)
                                        ? (
                                            managerActual?.telefone ||
                                            managerActual?.telefone_2
                                        )?.replace(/\D/g, '')
                                        : (
                                            site?.Dados?.tel1 || site?.Dados?.tel2
                                        )?.replace(/\D/g, '')
                                }&text=Olá, vi este imóvel no site. Link: ${
                                    typeof window !== 'undefined' &&
                                    window.location.origin
                                }${
                                    typeof window !== 'undefined' &&
                                    window.location.pathname
                                }`}
                                className={styles.widthSet}
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (
                                                    site?.Dados?.tel1 || site?.Dados?.tel2
                                                )?.replace(/\D/g, '')
                                        }&text=Olá, vi este imóvel no site. Link: ${
                                            typeof window !== 'undefined' &&
                                            window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }` : `https://api.whatsapp.com/send?phone=55${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (
                                                    site?.Dados?.tel1 || site?.Dados?.tel2
                                                )?.replace(/\D/g, '')
                                        }&text=Olá, vi este imóvel no site. Link: ${
                                            typeof window !== 'undefined' &&
                                            window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático
                                
                                    trackLead(site, detailsProperties); // 🔥 Registra o evento Lead
                                
                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (
                                                    site?.Dados?.tel1 || site?.Dados?.tel2
                                                )?.replace(/\D/g, '')
                                        }&text=Olá, vi este imóvel no site. Link: ${
                                            typeof window !== 'undefined' &&
                                            window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }` : `https://api.whatsapp.com/send?phone=55${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (
                                                    site?.Dados?.tel1 || site?.Dados?.tel2
                                                )?.replace(/\D/g, '')
                                        }&text=Olá, vi este imóvel no site. Link: ${
                                            typeof window !== 'undefined' &&
                                            window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    style={{ marginRight: 10 }}
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg>
                                <div>
                                    Converse pelo Whatsapp
                                </div>
                            </a>
                        </div>
                    :null }
                    <div className={styles.action_more_whatsapp}>
                        <a
                            className={styles.widthSet}
                            rel="noopener noreferrer"
                            href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                        (managerActual?.id)
                                            ? (
                                                managerActual?.telefone ||
                                                managerActual?.telefone_2
                                            )?.replace(/\D/g, '')
                                            : (
                                                site?.Dados?.tel1 || site?.Dados?.tel2
                                            )?.replace(/\D/g, '')
                                    }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }` : `https://api.whatsapp.com/send?phone=55${
                                        (managerActual?.id)
                                            ? (
                                                managerActual?.telefone ||
                                                managerActual?.telefone_2
                                            )?.replace(/\D/g, '')
                                            : (
                                                site?.Dados?.tel1 || site?.Dados?.tel2
                                            )?.replace(/\D/g, '')
                                    }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático
                            
                                trackLead(site, detailsProperties); // 🔥 Registra o evento Lead
                            
                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${
                                        (managerActual?.id)
                                            ? (
                                                managerActual?.telefone ||
                                                managerActual?.telefone_2
                                            )?.replace(/\D/g, '')
                                            : (
                                                site?.Dados?.tel1 || site?.Dados?.tel2
                                            )?.replace(/\D/g, '')
                                    }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }` : `https://api.whatsapp.com/send?phone=55${
                                        (managerActual?.id)
                                            ? (
                                                managerActual?.telefone ||
                                                managerActual?.telefone_2
                                            )?.replace(/\D/g, '')
                                            : (
                                                site?.Dados?.tel1 || site?.Dados?.tel2
                                            )?.replace(/\D/g, '')
                                    }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                height="24px"
                                width="24px"
                                viewBox="0 0 485.213 485.212"
                                style={{ marginRight: 10 }}
                            >
                                <path
                                    d="M60.652,75.816V15.163C60.652,6.781,67.433,0,75.817,0c8.38,0,15.161,6.781,15.161,15.163v60.653
                                    c0,8.38-6.781,15.161-15.161,15.161C67.433,90.978,60.652,84.196,60.652,75.816z M318.424,90.978
                                    c8.378,0,15.163-6.781,15.163-15.161V15.163C333.587,6.781,326.802,0,318.424,0c-8.382,0-15.168,6.781-15.168,15.163v60.653
                                    C303.256,84.196,310.042,90.978,318.424,90.978z M485.212,363.906c0,66.996-54.312,121.307-121.303,121.307
                                    c-66.986,0-121.302-54.311-121.302-121.307c0-66.986,54.315-121.3,121.302-121.3C430.9,242.606,485.212,296.919,485.212,363.906z
                                    M454.89,363.906c0-50.161-40.81-90.976-90.98-90.976c-50.166,0-90.976,40.814-90.976,90.976c0,50.171,40.81,90.98,90.976,90.98
                                    C414.08,454.886,454.89,414.077,454.89,363.906z M121.305,181.955H60.652v60.651h60.653V181.955z M60.652,333.584h60.653V272.93
                                    H60.652V333.584z M151.629,242.606h60.654v-60.651h-60.654V242.606z M151.629,333.584h60.654V272.93h-60.654V333.584z
                                    M30.328,360.891V151.628h333.582v60.653h30.327V94c0-18.421-14.692-33.349-32.843-33.349h-12.647v15.166
                                    c0,16.701-13.596,30.325-30.322,30.325c-16.731,0-30.326-13.624-30.326-30.325V60.651H106.14v15.166
                                    c0,16.701-13.593,30.325-30.322,30.325c-16.733,0-30.327-13.624-30.327-30.325V60.651H32.859C14.707,60.651,0.001,75.579,0.001,94
                                    v266.892c0,18.36,14.706,33.346,32.858,33.346h179.424v-30.331H32.859C31.485,363.906,30.328,362.487,30.328,360.891z
                                    M303.256,242.606v-60.651h-60.648v60.651H303.256z M409.399,363.906h-45.49v-45.49c0-8.377-6.781-15.158-15.163-15.158
                                    s-15.159,6.781-15.159,15.158v60.658c0,8.378,6.777,15.163,15.159,15.163h60.653c8.382,0,15.163-6.785,15.163-15.163
                                    C424.562,370.692,417.781,363.906,409.399,363.906z"
                                />
                            </svg>
                            Agendar Visita
                        </a>
                    </div>
                </div>
            );
        }
        if (openForm === 'concluded') {
            return renderFormStepLast('web');
        }
    };

    const actionViewProperties = async (user: any) => {
        try {
            await viewProperties(detailsProperties?.id, user?.id_client || '', origin, codsite);
        } catch (error) {
            // console.log(error)
        }
    };

    // Função que constrói a string de dimensão com base na lógica original
    const renderDimensions = (): string => {
        // Extrai os valores ou define como string vazia se forem undefined/nulos
        const frente = detailsProperties?.frente || "";
        const fundos = detailsProperties?.fundos || "";
        const ladoEsquerdo = detailsProperties?.lado_esquerdo || "";
        const ladoDireito = detailsProperties?.lado_direito || "";
    
        // Se pelo menos um valor estiver presente
        if (frente || fundos || ladoEsquerdo || ladoDireito) {
        let dimensao = "";
    
        // Caso 1: frente igual a fundos e ladoEsquerdo igual a ladoDireito
        if (frente === fundos && ladoEsquerdo === ladoDireito) {
            let ld = ladoDireito;
            // Se ambos estiverem preenchidos, adiciona " x " antes do ladoDireito
            if (ld && frente) {
            ld = " x " + ld;
            }
            dimensao = frente + ld;
        }
        // Caso 2: frente igual a fundos, mas ladoEsquerdo diferente de ladoDireito
        else if (frente === fundos && ladoEsquerdo !== ladoDireito) {
            let f = frente;
            let le = ladoEsquerdo;
            if (f) {
            f = f + " x ";
            }
            if (le) {
            le = le + " x ";
            }
            dimensao = f + le + ladoDireito;
        }
        // Caso 3: frente diferente de fundos e ladoEsquerdo igual a ladoDireito
        else if (frente !== fundos && ladoEsquerdo === ladoDireito) {
            let f = frente;
            let le = ladoEsquerdo;
            if (le) {
            le = "x" + le;
            }
            if (f) {
            f = f + " x ";
            }
            dimensao = f + fundos + le;
        }
        // Caso 4: frente diferente de fundos e ladoEsquerdo diferente de ladoDireito
        else if (frente !== fundos && ladoEsquerdo !== ladoDireito) {
            let f = frente;
            let fund = fundos;
            let le = ladoEsquerdo;
            if (f) {
            f = f + " x ";
            }
            if (fund) {
            fund = fund + " x ";
            }
            if (le) {
            le = le + " x ";
            }
            dimensao = f + le + ladoDireito;
        }
        return dimensao;
        }
        return "";
    };  

    useEffect(() => {
        try {
            const getUser: any = localStorage.getItem('user');
            const splitUser = JSON.parse(getUser || '');
            setExistUser(splitUser);
            setIsEffect(true);
        } catch (error) {}
    }, [openForm]);

    useEffect(() => {
        if (existUser) {
            setName(existUser?.name || '');
            setEmail(existUser?.email || '');
            setTelephone(existUser?.telephone || '');
            if (openForm === 'concluded') {
                actionViewProperties(existUser);
            }
        }
    }, [existUser]);

    useEffect(() => {
        if (isEffect) {
            actionViewProperties(existUser);
        }else {
            actionViewProperties(undefined);
        }
    }, [isEffect]);

    return (
        <div className={styles.oneStep}>
            {size?.width <= 750 ? (
                <>
                    <div
                        className={styles.button_form}
                        onClick={activeOpenForm}
                        style={stylesButton}
                    >
                        Tenho interesse
                    </div>
                </>
            ) : null}
            {size?.width <= 750 && openForm !== 'close' ? (
                <>
                    {openForm === 'open' ? renderFormStepOne('mobile') : null}
                    {openForm === 'concluded'
                        ? renderFormStepLast('mobile')
                        : null}
                </>
            ) : null}
            {site?.modelo_pagina_imovel == 1 ?
                <>
                    <label className={styles.title}>
                        {site?.id == 2178 && detailsProperties?.origem == "Orulo" ? `${
                        detailsProperties?.tipo?.nome || ''
                    } em ${detailsProperties?.cidade?.nome || ''}` :`
                        ${detailsProperties?.bairro?.nome ? (detailsProperties?.bairro?.nome + ", ") : ''}
                        ${detailsProperties?.cidade?.nome || ''}
                        ${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}
                        `}
                    </label>
                    {site?.id != 2178 || detailsProperties?.origem != "Orulo" ?
                    <label className={styles.subtitle}>{`${
                        detailsProperties?.tipo?.nome || ''
                    } em ${detailsProperties?.cidade?.nome || ''}`}</label>: null}
                    {detailsProperties?.mostrar_endereco && detailsProperties?.endereco && !site?.ocultar_endereco ?
                        <label className={styles.endereco}>{`Endereço: ${detailsProperties?.endereco}`}</label>
                    : null}
                </>
            : null}
            <div className={styles.container_info} style={site?.modelo_pagina_imovel == 3 ? {padding: "0px 2.5%"} : {}}>
                <div className={styles.info_properties} style={site?.modelo_pagina_imovel == 3 ? {width: "calc(100% - 400px)"} : {}}>
                    {site?.modelo_pagina_imovel == 1 ?
                    <>
                        <label>{`Cod. ${
                            detailsProperties?.referencia || ''
                        }`}</label>
                        { detailsProperties?.temporada && detailsProperties?.d1 > 0
                        ? (
                            <label
                                className={
                                    styles.text_price
                                }
                            >
                                {site?.id != '1667' ?
                                    <>
                                {`Diária: ${site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.d1,
                                    2
                                )}`}
                                </>
                                : <>Diária: Sob Consulta</>}
                            </label>
                        ) : null}
                        {detailsProperties?.venda ?
                            Number(
                                detailsProperties?.exibir_preco_venda &&
                                    detailsProperties?.preco_venda
                            ) ? (
                                <label
                                    className={
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                >
                                    {`Venda: ${site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_venda,
                                        2
                                    )}`}
                                </label>
                            ) : <label
                                    className={
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                >
                                    {`Venda: Valor sob Consulta`}
                                </label> : null}
                        {detailsProperties?.venda ?
                            detailsProperties?.preco_especial?.preco_especial_venda &&
                                detailsProperties?.exibir_preco_venda &&
                                detailsProperties?.preco_venda ? (
                                <label className={styles.text_price}>
                                    {`Por: ${site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda,
                                        2
                                    )}`}
                                </label>
                            ) : null
                            :null
                        }

                        {Number(
                            detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao
                        ) ? (
                            <label
                                className={
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao
                                        ? styles.text_price_oferta
                                        : styles.text_price
                                }
                            >
                                {`Aluguel: ${site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.preco_locacao,
                                    2
                                )}`}
                            </label>
                        ) : null}

                        {detailsProperties?.preco_especial
                            ?.preco_especial_locacao &&
                        detailsProperties?.exibir_preco_locacao &&
                        detailsProperties?.preco_locacao ? (
                            <label className={styles.text_price}>
                                {`Por: ${site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao,
                                    2
                                )}`}
                            </label>
                        ) : null}
                        {detailsProperties?.exibir_preco_iptu &&
                        detailsProperties?.preco_iptu > 0 ? (
                            <label>{`IPTU: ${site?.moeda_tipo} ${toPrice(
                                detailsProperties?.preco_iptu,
                                2
                            )}`}</label>
                        ) : null}
                        {detailsProperties?.exibir_preco_condominio &&
                        detailsProperties?.preco_condominio > 0 ? (
                            <label>{`CONDOMÍNIO: ${site?.moeda_tipo} ${toPrice(
                                detailsProperties?.preco_condominio,
                                2
                            )}`}</label>
                        ) : null}
                        {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                            <label style={{fontWeight: 'bold', fontSize: 24}}>
                                {`Total: ${site?.moeda_tipo} ${toPrice(calcularTotal(
                                    detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                    detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                    detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                ),2)}`}
                            </label>
                            : null
                        }
                    </>
                    : null}
                    <p className={styles.title_caracters}>
                        <b>CARACTERÍSTICAS </b>
                        DO IMÓVEL
                    </p>
                    {detailsProperties?.tipo?.nome
                        ? RenderDetails(
                              'Tipo do Imóvel',
                              detailsProperties?.tipo?.nome || 0
                          )
                        : null}
                    {detailsProperties?.area_construida > 0
                        ? RenderDetails(
                              'Área Construída',
                              NumeroFormatado(Number(detailsProperties?.area_construida)) + " " + ('m²')
                          )
                        : null}
                    {detailsProperties?.area_total > 0
                        ? RenderDetails(
                              'Área Total',
                              NumeroFormatado(Number(detailsProperties?.area_total)) + " " + (detailsProperties?.area_tipo || 'm²')
                          )
                        : null}
                    {detailsProperties?.terreno > 0
                        ? RenderDetails(
                              'Terreno',
                              NumeroFormatado(Number(detailsProperties?.terreno)) + " " + (detailsProperties?.area_tipo || 'm²')
                          )
                        : null}
                    {detailsProperties?.area_privativa > 0
                        ? RenderDetails(
                              'Área Privativa',
                              NumeroFormatado(Number(detailsProperties?.area_privativa)) + " " + (detailsProperties?.area_tipo || 'm²')
                          )
                        : null}
                    {
                        detailsProperties?.lado_direito ||
                        detailsProperties?.lado_esquerdo ||
                        detailsProperties?.frente ||
                        detailsProperties?.fundos ? (
                            RenderDetails('Dimensões', renderDimensions())
                        ) : null
                    }
                    {detailsProperties?.area_util > 0
                        ? RenderDetails(
                              'Área Útil',
                              NumeroFormatado(Number(detailsProperties?.area_util)) + " " + (detailsProperties?.area_tipo || 'm²')
                          )
                        : null}
                    {detailsProperties?.dormitorios > 0 && detailsProperties?.dormitorios >= detailsProperties?.suites
                    ? RenderDetails(
                            'Dormitórios',
                            `${detailsProperties?.dormitorios || 0} ${detailsProperties?.suites > 0 ? detailsProperties?.suites == 1 ? " (Sendo 1 Suíte)" : " (Sendo "+detailsProperties?.suites+" Suítes)" : ""}`
                        )
                    :
                        <>
                            {detailsProperties?.dormitorios > 0
                            ? RenderDetails(
                                    'Dormitórios',
                                    detailsProperties?.dormitorios || 0
                                )
                            : null}
                            {detailsProperties?.suites > 0
                            ? RenderDetails(
                                    'Suítes',
                                    detailsProperties?.suites || 0
                                )
                            : null}
                        </>
                    }
                    {detailsProperties?.banheiros > 0
                        ? RenderDetails(
                              'Banheiros',
                              detailsProperties?.banheiros || 0
                          )
                        : null}
                    {detailsProperties?.garagems > 0
                        ? RenderDetails(
                              'Vagas',
                              detailsProperties?.garagems || 0
                          )
                        : null}
                    {detailsProperties?.posicao_solar
                    ? RenderDetails(
                            'Posição Solar',
                            detailsProperties?.posicao_solar || ""
                        )
                    : null}
                    {formatarDataEntrega(Number(detailsProperties?.data_entrega)) != "false" && detailsProperties?.data_entrega && site?.mostrar_data_entrega
                        ? RenderDetails(
                              'Data de Entrega',
                              formatarDataEntrega(Number(detailsProperties?.data_entrega))
                          )
                    : null}
                    {site?.id == "1892" && detailsProperties?.data_edicao ?
                        <label style={{margin: "20px 0px 0px 0px", fontSize: "14px"}}>Data última edição: {arrumaData(detailsProperties?.data_edicao)}</label>
                    : null}
                    {detailsProperties?.incorporacao ?
                        <p className={styles.title_caracters}><b>INCORPORAÇÃO:</b> {detailsProperties?.incorporacao}</p>
                    : null
                    }
                    <p className={styles.title_caracters}>

                    <b>DESCRIÇÃO </b>
                        DO IMÓVEL
                    </p>
                    {site?.Dados?.inicio_txt_descricao ? (
                        <p className={styles.description_properties}>
                            {Desc(site?.Dados?.inicio_txt_descricao)}
                    </p>
                    ) : null}
                    {detailsProperties?.descricao ? (
                        <div>
                            <div
                                ref={textoRef}
                                className={`${styles.description_properties} ${
                                    expandido || !exibirBotao ? styles.expandido : styles.colapsado
                                }`}
                            >
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: Desc2(detailsProperties?.descricao),
                                    }}
                                ></p>
                                {site?.Dados?.final_txt_descricao ? (
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: Desc2(site?.Dados?.final_txt_descricao),
                                        }}
                                    ></p>
                                ) : null}
                            </div>
                            {exibirBotao ? 
                                <button
                                    className={styles.toggleButton}
                                    onClick={() => setExpandido(!expandido)}
                                >
                                    {expandido ? (
                                        <span><FaChevronUp style={{marginRight: "5px"}}/>Ver menos</span>
                                    ) : (
                                        <span><FaChevronDown style={{marginRight: "5px"}}/>Ver mais</span>
                                    )}
                                </button>
                            : null}
                        </div>
                    ) : null}
                    { detailsProperties?.caracteristicas?.length > 0  ? (
                        <>
                            {   detailsProperties?.caracteristicas?.some((caracteristica: any) => caracteristica?.caracteristica?.tipo === "unidade") ?
                                <>
                                    <p className={styles.title_caracters}>
                                        <b>CARACTERÍSTICAS </b>
                                        DA UNIDADE
                                    </p>
                                    <div className={styles.all_caracters}>
                                        { detailsProperties?.caracteristicas?.map((v: any) =>
                                            v?.caracteristica?.tipo == "unidade" && v?.caracteristica?.nome != "" ?
                                                    RenderInfoAdditionals(v?.caracteristica?.nome, 'carac'+v?.caracteristica?.id)
                                            :
                                                null)
                                        }
                                    </div>
                                </>
                            : null }
                            { detailsProperties?.caracteristicas?.some((caracteristica: any) => caracteristica?.caracteristica?.tipo === "condominio") ?
                                <>
                                    <p className={styles.title_caracters}>
                                        <b>CARACTERÍSTICAS </b>
                                        DO EMPREENDIMENTO
                                    </p>
                                    <div className={styles.all_caracters}>
                                        {detailsProperties?.caracteristicas?.map((v: any) =>
                                            v?.caracteristica?.tipo == "condominio" && v?.caracteristica?.nome != "" ? RenderInfoAdditionals(v?.caracteristica?.nome, v?.caracteristica?.id) : null
                                        )}
                                    </div>
                                </>
                            : null
                            }
                        </>
                    ) : null }

                    { site?.exibir_cidade_bairro_no_imovel && (detailsProperties?.cidade?.descricao || detailsProperties?.bairro?.descricao) ? (
                        <>
                            { detailsProperties?.cidade?.descricao &&
                                <div className={styles.descricao_local}>
                                    {detailsProperties?.cidade?.url_foto &&
                                        <img className={styles.descricao_local_imagem} src={detailsProperties?.cidade?.url_foto}/>
                                    }
                                    <div className={styles.descricao_localizacao}>
                                        <b style={{fontSize: 22}}>CONHEÇA A CIDADE {detailsProperties?.cidade?.nome.toUpperCase()}</b>
                                        {Desc1(detailsProperties?.cidade?.descricao)}
                                    </div>
                                </div>
                            }
                            { detailsProperties?.bairro?.descricao &&
                                <div className={styles.descricao_local}>
                                    {detailsProperties?.bairro?.url_foto &&
                                        <img className={styles.descricao_local_imagem} src={detailsProperties?.bairro?.url_foto}/>
                                    }
                                    <div className={styles.descricao_localizacao}>
                                        <b style={{fontSize: 22}}>CONHEÇA O BAIRRO {detailsProperties?.bairro?.nome.toUpperCase()}</b>
                                        {Desc1(detailsProperties?.bairro?.descricao)}
                                    </div>
                                </div>
                            }
                        </>
                    ) : null }
                </div>
                <div className={styles.adjust_form}>
                    {(url && site?.modelo_pagina_imovel == 1) || site?.id == 2246 ?
                        <div className={styles.compartilharContainer}>
                                <span>Compartilhe</span>
                                {site?.id != "1925" ?
                                    <div className={styles.icones}>
                                        {site?.id == 2246 ? 
                                            <a href={`https://pinterest.com/pin/create/button/?url=${url}`} target="_blank" rel="noreferrer">
                                                <FaPinterest style={{height: 30, width: 25}}/>
                                            </a>
                                        : null}
                                        <a href={`https://api.whatsapp.com/send?text=${url}`} target="_blank" rel="noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"/></svg></a>
                                        <a href={`https://www.linkedin.com/signup/cold-join?session_redirect=${url}`} target="_blank" rel="noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#0288d1" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/><path fill="#fff" d="M14 19H18V34H14zM15.988 17h-.022C14.772 17 14 16.11 14 14.999 14 13.864 14.796 13 16.011 13c1.217 0 1.966.864 1.989 1.999C18 16.11 17.228 17 15.988 17zM35 24.5c0-3.038-2.462-5.5-5.5-5.5-1.862 0-3.505.928-4.5 2.344V19h-4v15h4v-8c0-1.657 1.343-3 3-3s3 1.343 3 3v8h4C35 34 35 24.921 35 24.5z"/></svg></a>
                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank" rel="noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#039be5" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"/><path fill="#fff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"/></svg></a>
                                        <a href={`https://twitter.com/intent/tweet?url=${url}`} target="_blank" rel="noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#03A9F4" d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"/></svg></a>
                                    </div> :
                                    <div className={styles.icones}>
                                        <a href={`https://api.whatsapp.com/send?text=${url}`} target="_blank" rel="noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"/></svg></a>
                                    </div>
                                }
                        </div>
                    :null}
                    {(managerActual?.id && managerActual?.url_foto) ? (
                        <div className={styles.info_manager}>
                            <label className={styles.description_manager_top}>
                                Corretor responsável por esse imóvel
                            </label>
                            <label className={styles.title_manager}>
                                {managerActual?.nome}
                            </label>
                            {site?.id != '2091' ?
                                <label className={styles.description_manager}>
                                    {managerActual?.funcao?.nome}
                                </label>
                            : null}
                            {managerActual?.creci ?
                                <label className={styles.description_manager}>
                                    Creci: {managerActual?.creci}
                                </label>
                            :null}
                            {managerActual?.url_foto ? (
                                <img
                                    className={styles.img_manager}
                                    style={site?.id == 2259 ? {maxWidth: 200, maxHeight: 200} : {}}
                                    src={managerActual?.url_foto}
                                    alt='Foto Corretor'
                                />
                            ) : null}
                            <div className={styles.adjust_buttons}>
                                <a
                                    href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=Olá, vi este imóvel no site. Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }` : `https://api.whatsapp.com/send?phone=55${(
                                        managerActual?.telefone ||
                                        managerActual?.telefone_2
                                    )?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=Olá, vi este imóvel no site. Link: ${
                                        typeof window !== 'undefined' &&
                                        window.location.origin
                                    }${
                                        typeof window !== 'undefined' &&
                                        window.location.pathname
                                    }`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className={styles.button_zap}
                                >
                                    WHATSAPP
                                </a>
                                {!isMobile && managerActual?.instagram ?
                                    <a
                                        href={managerActual?.instagram}
                                        rel="noopener noreferrer"
                                        title="Instagram"
                                        target="_blank"
                                        className={styles.button_instagram}
                                    >
                                        INSTAGRAM
                                    </a>
                                    : 
                                    !isMobile && site?.Dados?.instagram ?
                                    <a
                                        href={site?.Dados?.instagram}
                                        rel="noopener noreferrer"
                                        title="Instagram"
                                        target="_blank"
                                        className={styles.button_instagram}
                                    >
                                        INSTAGRAM
                                    </a>
                                    : null
                                }
                            </div>
                        </div>
                    ) : null}
                    {size?.width > 750 ? (
                        <div className={styles.box}>{renderForm()}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default DetailsPiecesProperties;
